function ScrumMasterDocumentation() {
  return <>Scrum Master Documentation</>;
}

export default ScrumMasterDocumentation;
